import FlagProvider, {
  type IConfig,
  useUnleashContext,
} from '@unleash/proxy-client-react';
import { useEffect } from 'react';

import { useGetLoggedInUser } from '@revelio/auth';
import { unleashUserProperties } from '@revelio/iso-utility';

import { environment } from '../../environments/environment';
import { UnleashFallback } from './unleash-fallback';

const unleashedConfig: IConfig = {
  url: environment.UNLEASH_URL,
  clientKey: environment.UNLEASH_CLIENT_KEY,
  refreshInterval: 15,
  appName: 'reveliolabs-dashboard',
};

export const UnleashFlags = ({ children }: { children: React.ReactNode }) => {
  return (
    <FlagProvider config={unleashedConfig}>
      <UnleashFallback>{children}</UnleashFallback>
      <SyncUnleashClientName />
    </FlagProvider>
  );
};

const SyncUnleashClientName = () => {
  const { loggedInUser } = useGetLoggedInUser();
  const updateContext = useUnleashContext();

  useEffect(() => {
    updateContext({
      userId: loggedInUser?.id ?? undefined,
      properties: unleashUserProperties(loggedInUser),
    });
  }, [loggedInUser, updateContext]);
  return null;
};
